import { useState } from "react"
import { array, object } from "prop-types"
import axios from "axios"
import pcoURL from "@planningcenter/url"

import OrganizationsTable from "./OrganizationsTable"
import TimeseriesChart from "./TimeseriesChart"

const StaffOverageDetail = ({ organizations, pagination }) => {
  const [chartConfig, setChartConfig] = useState({
    timeframe: "monthly",
    countBy: "organizations",
    organizationAcid: ""
  })
  const [chartLoading, setChartLoading] = useState(false)
  const [chartData, setChartData] = useState([])

  const handleChartConfigChange = key => {
    return event => {
      setChartConfig(prevConfig => ({
        ...prevConfig,
        [key]: event.target.value
      }))
    }
  }

  const showChart = config => {
    setChartLoading(true)
    axios
      .get(`${pcoURL(window.railsEnv)("registrations")}/staff/overages/chart`, {
        params: {
          timeframe: config.timeframe,
          count_by: config.countBy,
          organization_acid: config.organizationAcid
        }
      })
      .then(response => {
        setChartData(response.data)
        setChartLoading(false)
      })
      .catch(error => {
        if (error?.response?.status === 404) {
          alert("Organization not found. Please check the ID and try again.")
        }
        setChartData([])
        setChartLoading(false)
      })
  }

  const handleShowChart = () => {
    showChart(chartConfig)
  }

  const handleChartOrganization = organizationAcid => {
    return () => {
      setChartConfig(prevConfig => {
        const newConfig = {
          ...prevConfig,
          countBy: "events",
          organizationAcid: organizationAcid?.toString() || ""
        }
        showChart(newConfig)
        return newConfig
      })
    }
  }

  return (
    <>
      <div className="pane mt-4">
        <div className="pane__header">
          <h2 className="pane__title">Historical Overages</h2>
        </div>
        <div className="p-2">
          <div className="d-f">
            <select
              className="select"
              value={chartConfig.timeframe}
              onChange={handleChartConfigChange("timeframe")}
            >
              <option value="daily">Daily Timeframe</option>
              <option value="weekly">Weekly Timeframe</option>
              <option value="monthly">Monthly Timeframe</option>
            </select>
            <select
              className="ml-2 select"
              value={chartConfig.countBy}
              onChange={handleChartConfigChange("countBy")}
            >
              <option value="events">Count Events</option>
              <option value="organizations">Count Organizations</option>
            </select>
            <div className="ml-2 w-100%">
              <input
                type="text"
                value={chartConfig.organizationAcid}
                onChange={handleChartConfigChange("organizationAcid")}
                placeholder="Organization ID (optional)"
              />
            </div>
            <button
              className="btn-solid interaction ml-2"
              onClick={handleShowChart}
              disabled={chartLoading}
            >
              Show Chart
            </button>
          </div>
          {!chartLoading && chartData.length > 0 && (
            <div className="mt-2">
              <TimeseriesChart data={chartData} />
            </div>
          )}
        </div>
      </div>

      <div className="pane mt-4">
        <div className="pane__header">
          <h2 className="pane__title">Organizations with Overages</h2>
        </div>
        <div className="p-2">
          <OrganizationsTable
            organizations={organizations}
            pagination={pagination}
            onChartOrganization={handleChartOrganization}
          />
        </div>
      </div>
    </>
  )
}

StaffOverageDetail.propTypes = {
  organizations: array,
  pagination: object
}

export default StaffOverageDetail
